/**
 * Formats a Date as US-notation time locked to UTC — identical output for every user.
 * Uses Intl under the hood via toLocaleString with timeZone:'UTC'.
 *
 * @param d      The Date to format (must already be a valid Date object)
 * @param format 'short' → M/D/YYYY, h:mm AM/PM  |  'full' → M/D/YYYY, h:mm:ss AM/PM
 */
export function formatUtcDate(d: Date, format: 'full' | 'short' | 'date' | 'time' = 'short'): string {
  const base: Intl.DateTimeFormatOptions = { timeZone: 'UTC' };

  switch (format) {
    case 'date':
      return d.toLocaleDateString('en-US', { ...base, month: '2-digit', day: '2-digit', year: 'numeric' });
    case 'time':
      return d.toLocaleTimeString('en-US', { ...base, hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true });
    case 'short':
      return d.toLocaleString('en-US', { ...base, month: '2-digit', day: '2-digit', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true });
    case 'full':
    default:
      return d.toLocaleString('en-US', { ...base, month: '2-digit', day: '2-digit', year: 'numeric', hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true });
  }
}
